import { ControlcenterMelcoModelsThreadChart, VerticalForm } from "melco-shared-logic"
import { SavePublishHeader } from "../header/SavePublishHeader"
import { Spin, Tabs, TabsProps } from "melco-ui"
import { useRevertThreads } from "../../hooks/threads/useRevertThread"
import { BasicThreadTab } from "./tabs/BasicThreadTab"
import { DisplayCustomThreadFormErrors } from "./DisplayCustomThreadFormErrors"
import { useTranslation } from "react-i18next"
import { useDownloadThread } from "../../hooks/threads/useDownloadThread"
import { saveAs } from "file-saver"
import { FILE_FORMAT_THREAD } from "../../helper/commonHelper"
import { useState } from "react"
import { ThreadProductsTab } from "./tabs/ThreadProductsTab"
import { ThreadColorsTab } from "./tabs/ThreadColorsTab"
import styled from "styled-components"

type DisplayUpdateThreadFormProps = {
    thread: ControlcenterMelcoModelsThreadChart;
    refetch: any;
}

const TabsWrapper = styled.div`
  position: relative;
`;

/* Overlay (controlled by prop) */
const TabsOverlay = styled.div<{ $isUploading: boolean }>`
  position: absolute;
  inset: 0;
  z-index: 10;
  cursor: not-allowed;
  display: ${({ $isUploading }) => ($isUploading ? "block" : "none")};
`;


const StyledSpin = styled(Spin)`
  width: 100%;
`;

export const DisplayUpdateThreadForm: React.FC<DisplayUpdateThreadFormProps> = ({ thread, refetch }) => {

    const { created_date,
        publish_state,
        publish_date,
        updated_date,
        warning_list,
        id,

    } = thread;


    const [isCurrentlyDownloading, setIsCurrentlyDownloading] = useState(false)
    const [revertThreads, isLoading] = useRevertThreads(id!, refetch);
    const [downloadThread] = useDownloadThread(id ?? "")
    const threadFilename = `thread-${new Date().toISOString()}` + FILE_FORMAT_THREAD
    const [isUploading, setIsUploading] = useState(false);

    const downloadThreadAction = async () => {
        setIsCurrentlyDownloading(true)
        try {
            const blob = await downloadThread();
            console.log(blob);
            if (blob) {
                saveAs(blob, threadFilename);
            }
            else {
                console.log("It is not blob");
            }
            setIsCurrentlyDownloading(false)
        }
        catch (exp) {
            console.log("exception : ", exp)
            console.log(JSON.stringify(exp))
            setIsCurrentlyDownloading(false)
        }
    }

    const { t } = useTranslation();

    const items: TabsProps["items"] = [
        {
            key: "basic",
            label: t("managethreads.tabs.basic.title"),
            children: thread && thread?.id && <BasicThreadTab refetch={refetch} threadId={id!} setIsUploading={setIsUploading} />
        },
        {
            key: "colors",
            label: t("managethreads.tabs.colors.title"),
            children: <ThreadColorsTab />,
        },
        {
            key: "products",
            label: t("managethreads.tabs.products.title"),
            children: <ThreadProductsTab />
        },



    ]
    return <>

        <VerticalForm>

            <SavePublishHeader
                createdDate={created_date!}
                isCurrentlyReverting={isLoading}
                publishedState={publish_state!}
                revertAction={revertThreads}
                publishedDate={publish_date}
                updatedDate={updated_date}
                title="Details"
                warnings={warning_list ?? undefined}
                download={true}
                downloadAction={downloadThreadAction}
                isCurrentlyDownloading={isCurrentlyDownloading}
            />
            {/* <DisplayFieldErrors name="category_list" aggregateErrors /> */}
            <DisplayCustomThreadFormErrors />

            <TabsWrapper>
                <StyledSpin spinning={isUploading}>
                    <Tabs items={items} />
                </StyledSpin>

                {isUploading && <TabsOverlay $isUploading={isUploading} />}
            </TabsWrapper>
        </VerticalForm>

    </>
}